/**
 * @author        denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright     Copyright (c) 2022, Zumper
 */

import type {
  DistrictDetails as DistrictDetailsType,
  RawDistrictDetails,
  RawSchoolDistrict,
  SchoolDistrict as SchoolDistrictType,
} from '@zcode/state-type'

import { Bizo, autoclass } from '../../../shared/bizos/base'

const DISTRICT_DEFINITION = {
  districtId: 'school_district_id',
  name: 'name',
  totalSchools: 'total_schools',
  totalStudents: 'total_students',
  elementaryCount: 'elementary_count',
  middleCount: 'middle_count',
  highCount: 'high_count',
} as const

const District = autoclass<SchoolDistrictType, RawSchoolDistrict>(
  'SchoolDistrict',
  class SchoolDistrict extends Bizo<SchoolDistrictType, RawSchoolDistrict> {},
  DISTRICT_DEFINITION,
  null
)

const DEFINITION = {
  schoolDistricts: { name: 'school_districts', type: District, isArray: true },
} as const

export const DistrictDetails = autoclass<DistrictDetailsType, RawDistrictDetails>(
  'DistrictDetails',
  class DistrictDetails extends Bizo<DistrictDetailsType, RawDistrictDetails> {},
  DEFINITION,
  null
)

export default {
  fromJS: (data: RawSchoolDistrict[]) => {
    if (data) {
      if (Array.isArray(data)) {
        return data.map((district) => District.fromJS(district))
      }
    }
    return []
  },
}
